import apiClient from 'services/api';

export const getQuote = (viewToken: string) =>
  apiClient.get<Kudable.QuotePublicResponse>(`/public/quotes/${viewToken}`);

export const acceptQuote = (viewToken: string) =>
  apiClient.post<{
    quote: { status: string; accepted_at: string };
    booking: { view_token: string };
  }>(`/public/quotes/${viewToken}/accept`);

export const declineQuote = (viewToken: string, reason?: string) =>
  apiClient.post<{ quote: { status: string; declined_at: string } }>(
    `/public/quotes/${viewToken}/decline`,
    reason ? { reason } : {},
  );
